import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Company } from 'app/modules/domain/models/company';
import { AdminService } from 'app/modules/admin/services/admin.service';
import { Quota } from 'app/modules/domain/models/quota';
import { MdDialog } from '@angular/material';
import { AddCompanyComponent } from '../add-company/add-company.component';
import { DeleteCompanyComponent } from '../delete-company/delete-company.component';
import { EditCompanyComponent } from 'app/modules/admin/shared/edit-company/edit-company.component';

@Component({
  selector: 'app-organizations-list',
  templateUrl: './organizations-list.component.html',
  styleUrls: ['./organizations-list.component.scss']
})
export class OrganizationsListComponent {
  private _companies: Company[] = [];

  get companies(): Company[] {
    return this._companies;
  }

  @Input()
  set companies(val: Company[]) {
    this._companies = val;
    this.enrichCompanies();
  }

  @Output() onCompanySelect: EventEmitter<Company> = new EventEmitter<Company>();
  @Output() onUpdateCompanies: EventEmitter<void> = new EventEmitter<void>();

  public selectedCompany: Company;
  public filteredCompanies: Company[];

  constructor(private adminService: AdminService,
              public dialog: MdDialog) { }

  private enrichCompanies(): void {
    this.adminService.getQuotaForCompanies().subscribe((quotas: Quota[]) => {
      this._companies = this.companies.map(u => {
        const userInfo = quotas.find(q => q.userId === u.id);

        return {
          ...u,
          limit: userInfo && userInfo.limit
        };
      });
      this.filteredCompanies = this.companies;
    });
  }

  public onSearch(event): void {
    const searchString = event.target.value.toLocaleLowerCase();
    if (!searchString || searchString === '') {
      this.filteredCompanies = this.companies;
    } else {
      this.filteredCompanies = this.companies.filter(u => {
        return u.name.toLocaleLowerCase().includes(searchString);
      });
    }
  }

  public onRowClick(company: Company) {
    if (!this.selectedCompany || company.id !== this.selectedCompany.id) {
      this.selectedCompany = company;
      this.onCompanySelect.emit(company);
    }
  }

  public addCompany() {
    const dialogRef = this.dialog.open(AddCompanyComponent, {
      width: '450px'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.doAddCompany(result);
    });
  }

  private doAddCompany(company: Company) {
    this.adminService.addNewOrganization(company).subscribe(() => {
      this.onUpdateCompanies.emit();
    });
  }

  public editCompany(company: Company) {
    const dialogRef = this.dialog.open(EditCompanyComponent, {
      width: '450px',
      data: { company }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.doEditCompany({
        id: company.id,
        name: result.name,
        maxAllowedUsers: result.maxAllowedUsers
      });
    });
  }

  private doEditCompany(company: Company) {
    this.adminService.updateCompany(company).subscribe((result) => {
      this.onUpdateCompanies.emit();
    });
  }

  public deleteCompany(company: Company) {
    const dialogRef = this.dialog.open(DeleteCompanyComponent, {
      width: '450px',
      data: { company }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.doDeleteCompany(company.id, result);
    });
  }

  private doDeleteCompany(companyId: string, deleteToken: string) {
    this.adminService.deleteCompany(companyId, deleteToken).subscribe((result) => {
      this.onUpdateCompanies.emit();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/organisations/components/organizations-list/organizations-list.component.ts